import React from 'react'
import styled from 'styled-components'

type StyledImgProps = {
  src: string,
  size: number,
  borderWidth: number
}

const StyledImg = styled.div<StyledImgProps>`
  border-radius: 50%;
  min-width: ${props => props.size ? props.size : '26'}px;
  min-height: ${props => props.size ? props.size : '26'}px;
  width: ${props => props.size ? props.size : '26'}px;
  height: ${props => props.size ? props.size : '26'}px;
  display: inline-block;
  vertical-align: middle;
  border: ${props => props.borderWidth ? props.borderWidth : '0'}px solid #2D055B;
  background: url("${(props) => props.src}") no-repeat center;
  background-size: cover;
`

const Avatar = (props: any) => {
    return <StyledImg {...props}/>
}


export default Avatar
